module.exports = __webpack_public_path__ + "img/glassthickness-minus.71bfe18f.svg";